import * as React from 'react';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { FormField, Input, Container, Row, Col, Box, Layout, Cell, Text } from 'wix-style-react';
import { DataHooks } from '@src/constants/data-hooks';
import { AppContext } from '@src/context/store';
import { getTranslations } from '@src/context/selectors/ui-settings';
import { CategoriesData } from './categories-data';
import { CategoryTabs } from './category-tabs';
import { CategoryHeadline } from './category-headline';
import { ParagraphEditorRows } from './paragraph-editor';

import * as css from '../categories.scss';

export const CategoriesEditors = translate()(({ t }: InjectedTranslateProps) => {
  const [selectedTab, setTab] = React.useState(1);
  const store = React.useContext(AppContext);
  const translations = getTranslations(store);

  const selectedCategory = CategoriesData[selectedTab - 1];
  const { headlineKey, paragraphKey, titleDisabled, headlineMaxLen, paragraphMaxLen } = selectedCategory;

  const updateStore = (key: string, value: string) => store.updatePendingTranslations({ [key]: value });
  const onTitleChange = (value: string) => updateStore(headlineKey, value);

  return (
    <Box className={css.categories} dataHook={DataHooks.AdvancedEditorsContainer}>
      <Layout gap={0} justifyItems="top" alignItems="top">
        <Cell vertical span={4}>
          <CategoryTabs selectedTab={selectedTab} setTab={setTab} />
        </Cell>
        <Cell vertical span={8}>
          <Box className={css.divider}></Box>
          <Box paddingLeft="35px" paddingTop="12px">
            <Container fluid>
              <Row>
                <Col>
                  <CategoryHeadline title={selectedCategory.title} tooltip={selectedCategory.tooltip} />
                </Col>
              </Row>
              <Row>
                <Col span={3}>
                  <FormField label={t('advanced-options.categories.text.headline')} />
                </Col>
                <Col span={8}>
                  <Input
                    dataHook={DataHooks.AdvancedEditorsText}
                    maxLength={headlineMaxLen}
                    disabled={titleDisabled === true}
                    value={translations[headlineKey]}
                    onChange={(event) => onTitleChange(event.target.value)}
                  />
                </Col>
                <Col span={1}>
                  <Text skin="disabled">
                    {titleDisabled !== true && headlineMaxLen - translations[headlineKey].length}
                  </Text>
                </Col>
              </Row>
              <ParagraphEditorRows
                paragraphKey={paragraphKey}
                maxLength={paragraphMaxLen}
                value={translations[paragraphKey]}
                onChange={(value) => updateStore(paragraphKey, value)}
              />
            </Container>
          </Box>
        </Cell>
      </Layout>
    </Box>
  );
});
